import styled from 'styled-components';

export const ShowroomCardContainer = styled.div<{ $bgColor?: string }>`
    background-color: ${(props) => props.$bgColor || props.theme.uiBricks?.priceHeaderBackgroundColor || '#f4f4f4'};
    padding: 16px;
    width: 100%;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    gap: 30px;
`;
